module.exports = {"previewCurrentPlan":"Your current plan: "}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/FeaturePreview/localization/en-GB/strings.json
// module id = 814
// module chunks = 0